<template>
    <div>
        <el-row>
            <el-col :span="6">
                <!-- KPI部门树 -->
                <el-container >
                    <el-aside style="width:100%;">
                        <el-input size="small" style="margin-bottom:12px;margin-top:12px;"  placeholder="输入关键字进行过滤" v-model="filterText"></el-input>                
                        <el-tree class="filter-tree" :data="data" :props="defaultProps" node-key="id" @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </el-aside>
                </el-container>
            </el-col>
            <el-col :span="17" style="float:right;margin-top:12px;" >
                <!-- 搜索条件 -->
                <el-row class="viewKPITitle">
                    <el-col :span="4">
                        <el-input size="small"  placeholder="人员姓名" v-model="title"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                    </el-col>
                </el-row>
                <!-- 头部信息 -->
                <div style="margin-bottom:50px;" v-for="item in AllKPIInfo" :key="item.sysUser.Id" > 
                    <div style="margin-top:20px;background-color: #f0f2f2;padding-top: 10px;padding-bottom: 15px;" class="viewKPITitle">
                        <el-row style="margin-top:10px;text-align:center;">{{item.sysUser.MainDeptsName}} KPI考核表</el-row>
                        <el-row style="margin-top:10px;">
                            <el-col :span="6">
                                被考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.sysUser.TrueName}}</span>
                            </el-col>
                            <el-col :span="6">
                                被考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.sysUser.Duty}}</span>
                            </el-col>
                            <el-col :span="6">
                                被考核者工号：<span v-if="AllKPIInfo.length>0">{{item.sysUser.UserCode}}</span>
                            </el-col>
                            <el-col :span="6">
                                考核周期：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].Period}}{{item.userKPI[0].PeriodType==0?'月':'季度'}}</span>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px;">
                            <el-col :span="6">
                                考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadTrueName}}</span>
                            </el-col>
                            <el-col :span="6">
                                考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadDuty}}</span>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 考核列表信息  show-summary :summary-method="getSummaries"-->
                    <el-table border show-summary :summary-method="getSummaries" :data="item.userKPI" style="width: 100%;margin-top:20px;" v-loading="loading" size="small">
                        <el-table-column label="KPI类型">
                            <template slot-scope="scope">
                                {{scope.row.KPIType == 0 ? "职能" : (scope.row.KPIType == 1 ? "业绩" : (scope.row.KPIType == 2 ? "自定义" : (scope.row.KPIType == 3 ? "其它" : (scope.row.KPIType == 4 ? "内部管理指标" : (scope.row.KPIType == 5 ? "客户指标" : (scope.row.KPIType == 6 ? "敬业度" : (scope.row.KPIType == 7 ? "重点项目" : "团队管理")))))))}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="KPI"  label="KPI名称"></el-table-column>
                        <el-table-column prop="KPIWeight" label="KPI权重"></el-table-column>
                        <el-table-column min-width="180" prop="Explain" label="指标说明"></el-table-column>
                        <el-table-column min-width="240" prop="Contents" label="考核细则"></el-table-column>
                        <el-table-column label="周期">
                            <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
                        </el-table-column>
                        <el-table-column min-width="180" prop="Execution" label="完成情况"></el-table-column>
                        <el-table-column prop="SelfScore" label="自评评分">
                            <template slot-scope="scope">
                                {{scope.row.Status == 0 ?'':scope.row.SelfScore}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="LeadScore" label="直属领导评分">
                            <template slot-scope="scope">
                                {{scope.row.LeadStatus == 0 ?'':scope.row.LeadScore}}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                
                <el-row >
                    <el-col :span="24">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="pageSizes"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount"
                            style="float:right"
                        ></el-pagination>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { Decrypt,Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetTreeDeptsData,GetChargeDeptsByUserCode,GetPageUserKPIByDeptId,SendFrameResult } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {    
    props: {
        pt: {
            Type: Number
        },
        activeName:{
            Type:String
        }
    },
    watch: {
        //树状结构搜索
       filterText(val) {
         this.$refs.tree.filter(val);
       }
    },
    data(){
        return{
            isShowList:false,//是否显示右边菜单
            loading:false,
            data:[],//树形结构列表
            defaultProps: {
                children: 'nodes',
                label: 'text',
                disabled:'type'
            },
            currentRole:{},//获取当前用户角色
            currentUser:{},//获取当前用户
            FrameClickID:'',//部门id
            filterText: '',
            operationFrameList:'',//当前操作部门列表
            operationFrameId:'',//当前操作部门id
            deptModel:{},//当前操作部门
            pageSizes: [10, 20, 50, 100, 200],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
            title:'',//人员姓名
            AllKPIInfo:[],//获取KPI列表
            pType:this.pt,//0月度  1季度
            thisperiod:'',//当前操作周期
            isShowSend:false,//是否显示发送 true显示 false不显示
            disabled:false,//发送按钮是否禁用
        }
    },
    created(){
        //获取当前用户
        this.getCurrentUser();
        //获取当前用户角色
        this.getCurrentRole();
        //获取当前操作部门
        this.getCurrentDept();
        //获取部门树状结构
        this.getTreeDeptsData();
        this.getFrameKpiList();
        
    },
    methods:{
        //获取当前用户
        getCurrentUser:function(){
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取当前用户角色
        getCurrentRole:function(){
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));
        },
        //获取当前操作部门
        getCurrentDept:function(){
            var deptModelStory = window.sessionStorage.getItem("deptModel");
            if(deptModelStory==''||deptModelStory==null||deptModelStory=='undefined'){
                GetChargeDeptsByUserCode(this.currentUser.UserCode).then(res => {
                    if (res.list.length > 0) {
                        var dept={
                            value: res.list[0].Id,
                            label: res.list[0].ClassName
                        }
                        //将加密后的操作部门保存到session中
                        window.sessionStorage.setItem(
                            "deptModel",
                            Encrypt(JSON.stringify(dept))
                        );
                        this.deptModel=dept;
                        deptModelStory = window.sessionStorage.getItem("deptModel");
                    }
                });
            }
            this.deptModel=JSON.parse(Decrypt(deptModelStory));
            this.FrameClickID=this.deptModel.value;
        },
        //搜索条件
        SearchByName:function(){
            this.loading=true;
            this.getFrameKpiList();
        },
        //获取操作周期
        getThisPeriod:function(){
        this.thisperiod=new Date().getMonth();
            this.thisperiod=this.thisperiod+1;
            //  console.log('this.thisperiod1',this.thisperiod);
            // console.log('ptype',this.pType)
        //获取上个季度数据
        if(this.pType==1){
            //季度时 选择当前季度
            if(this.thisperiod>=1&&this.thisperiod<=3){
                this.thisperiod='Q4';
            }
            else if(this.thisperiod>=4&&this.thisperiod<=6){
                this.thisperiod='Q1';
            }
            else if(this.thisperiod>=7&&this.thisperiod<=9){
                this.thisperiod='Q2';
            }
            else{
                this.thisperiod='Q3';
            }
        }
        else
        {
            if(this.thisperiod==1){
                this.thisperiod=12;
            }
            else
            {
                this.thisperiod=this.thisperiod-1;
            }
        }
            //  console.log('this.thisperiod',this.thisperiod);
        },
        //获取部门树状结构
        getTreeDeptsData:function(){
            GetTreeDeptsData(this.deptModel.value,this.currentRole.Key).then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            })
        },
        //根据部门获取KPI列表
        getFrameKpiList:function(){
            var date=new Date();
            var year=date.getFullYear();
            
            //获取操作周期
            this.getThisPeriod();

            var month=date.getMonth();
            // console.log('month',month)
            
            if(this.thisperiod==12||this.thisperiod=='Q4'){
                //如果上个月是12月，则年份减1为上个月
                year=year-1;
            }

            //this.thisperiod 计划:当前月/季度  //结果:上月/上个季度
            //this.kpitype  0月度 1季度  
            GetPageUserKPIByDeptId(this.thisperiod,this.FrameClickID,year,this.pType,this.title,this.pageIndex,this.pageSize).then(res=>{
                if(res.totalCount<=0){
                    this.$message({
                        message: '暂无数据',
                        type: 'success'
                    });

                    return false;
                }
                this.AllKPIInfo=res.List;
                this.loading=false;
                this.totalCount=res.TotalCount;
            });
        },
        //节点点击事件
        handleNodeClick(data){
            this.FrameClickID= data.FrameID;
            this.loading=true;
            this.isShowList=true;
            

            //根据部门获取KPI列表
            this.getFrameKpiList();
        },        
        filterNode(value, data) {
            if (!value) return true;
            return data.text.indexOf(value) !== -1;
        },
        //分页条件搜索
        handleSizeChange(val) {
            this.pageSize = val;
            this.getFrameKpiList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getFrameKpiList();
        },
        //获取合计列
        getSummaries:function(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                else if(index === 2){
                    //第七列 自评分数合计
                    var quanzhong=0;
                    param.data.forEach((column, index) => {
                        quanzhong+=column.KPIWeight;
                    })
                    sums[index]=quanzhong;
                }
                else if(index === 7){
                    //第七列 自评分数合计
                    var SelfScoreAll=0;
                    param.data.forEach((column, index) => {
                        SelfScoreAll+=column.SelfScore;
                    })
                    sums[index]='自评总分：'+SelfScoreAll.toFixed(2);
                }
                else if(index===8){
                    //第八列 领导评分合计
                    var leadScoreAll=0;
                    param.data.forEach((column, index) => {
                        leadScoreAll+=column.LeadScore;
                    })
                    sums[index]='领导评分：'+leadScoreAll.toFixed(2);
                }
                
            });

            return sums;
        }
    }
}
</script>
<style lang="less" scoped>
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>
